export type ProspectQualification = Record<string, any>

export type ProspectStatut = 'lead' | 'contacte' | 'en_discussion' | 'proposition' | 'gagne' | 'perdu'
export type ProspectEmailStatus = 'pending' | 'sent' | 'opened' | 'replied' | 'bounced' | 'failed' | 'unsubscribed'
export type CallOutcome = 'interested' | 'callback' | 'not_interested' | 'no_answer' | 'voicemail' | 'other'

export interface ProspectCall {
  id: string
  prospect_id: string
  call_date: string
  duration_minutes: number | null
  call_script: string | null
  outcome: CallOutcome | null
  next_appointment: string | null
  notes: string | null
  contact_email: string | null
  rendez_vous_id: string | null
  created_by: string | null
  created_at: string
}

export const CALL_OUTCOME_LABELS: Record<CallOutcome, string> = {
  interested: 'Interesse',
  callback: 'A rappeler',
  not_interested: 'Pas interesse',
  no_answer: 'Pas de reponse',
  voicemail: 'Messagerie',
  other: 'Autre',
}

export const CALL_OUTCOME_COLORS: Record<CallOutcome, 'mint' | 'gold' | 'red' | 'gray' | 'blue' | 'purple'> = {
  interested: 'mint',
  callback: 'gold',
  not_interested: 'red',
  no_answer: 'gray',
  voicemail: 'blue',
  other: 'purple',
}

export interface Prospect {
  id: string
  // Entreprise
  siren: string | null
  siret: string | null
  raison_sociale: string | null
  nom_commercial: string | null
  forme_juridique: string | null
  capital: number | null
  naf: string | null
  secteur: string | null
  date_creation_entreprise: string | null
  etat_administratif: string | null
  nb_etablissements: number | null
  dirigeant: string | null
  // Localisation
  adresse: string | null
  code_postal: string | null
  ville: string | null
  departement: string | null
  // Contact
  telephone: string | null
  email: string | null
  site_web: string | null
  a_un_site: boolean | null
  technologie_site: string | null
  // Financier
  effectifs: string | null
  ca: number | null
  ca_annee: number | null
  resultat_net: number | null
  // Collecte
  source: string | null
  date_collecte: string | null
  // Audit
  audit: Record<string, any> | null
  // Scoring
  score_priorite: number | null
  score_besoin: number | null
  score_capacite: number | null
  score_timing: number | null
  scoring_details: Record<string, any> | null
  // Mockup
  mockup_html_path: string | null
  mockup_screenshot_path: string | null
  mockup_pdf_path: string | null
  mockup_style: Record<string, any> | null
  // Email
  email_status: ProspectEmailStatus | null
  email_subject: string | null
  email_body: string | null
  email_sent_at: string | null
  email_details: Record<string, any> | null
  // Qualification
  qualification: ProspectQualification | null
  // Suivi
  statut: ProspectStatut | null
  notes: string | null
  tags: string[] | null
  next_appointment: string | null
  contact_name: string | null
  // Metadata
  created_at: string | null
  updated_at: string | null
}

export const STATUT_LABELS: Record<ProspectStatut, string> = {
  lead: 'Lead',
  contacte: 'Contacte',
  en_discussion: 'En discussion',
  proposition: 'Proposition',
  gagne: 'Gagne',
  perdu: 'Perdu',
}

export const STATUT_COLORS: Record<ProspectStatut, 'blue' | 'gold' | 'purple' | 'mint' | 'red' | 'gray'> = {
  lead: 'blue',
  contacte: 'gold',
  en_discussion: 'purple',
  proposition: 'mint',
  gagne: 'mint',
  perdu: 'red',
}

export const EMAIL_STATUS_LABELS: Record<ProspectEmailStatus, string> = {
  pending: 'En attente',
  sent: 'Envoye',
  opened: 'Ouvert',
  replied: 'Repondu',
  bounced: 'Bounce',
  failed: 'Echoue',
  unsubscribed: 'Desinscrit',
}

export const EMAIL_STATUS_COLORS: Record<ProspectEmailStatus, 'gray' | 'blue' | 'gold' | 'mint' | 'red' | 'purple'> = {
  pending: 'gray',
  sent: 'blue',
  opened: 'gold',
  replied: 'mint',
  bounced: 'red',
  failed: 'red',
  unsubscribed: 'gray',
}

export type ScheduledProspectReminderStatus =
  | 'pending'
  | 'processing'
  | 'sent'
  | 'failed'
  | 'cancelled'

export interface ScheduledProspectReminder {
  id: string
  call_id: string
  prospect_id: string
  scheduled_at: string
  status: ScheduledProspectReminderStatus
  sent_at: string | null
  error: string | null
  attempts: number
  created_by: string | null
  created_at: string
  updated_at: string
}
